export default {
      id: "right-arrow-usage",
      viewBox: "0 0 16 10",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#right-arrow",
      toString: function () {
        return this.url;
      }
    }